'use strict';

function inputEntry() {
	$(document).on('keyup blur', '.search-text', function () {
		if ($(this).val().trim().length) {
			return $(this).siblings('button').prop('disabled', false);
		}

		$(this).siblings('button').prop('disabled', true);
	});
	$(document).on('blur keyup', '.cart-coupon-code input', function () {
		$('#add-coupon').prop('disabled', this.value == "" ? true : false);
	});
	$(document).on('change', '.form-row .user-consent-container input[type="checkbox"], .checkout-login-container .user-consent-container input[type="checkbox"]', function () {
		var fieldErrorWrapper = $(this).parents('.form-row').find('.error-placement'),
			form = $(this).parents('form'),
			validator = form.validate(),
			validElementFlag = validator.element($(this));
		if (validElementFlag === true && fieldErrorWrapper.length > 0) {
			fieldErrorWrapper.remove();
		}
		$(form).find('button[type$="submit"]').prop('disabled', $(form).find('.error-placement').length > 0 ? true : false);

		if($('.checkout-main-wrapper').length){
			var paypalContainer = $('.custom-paypal-container .error-placement').parents('.user-consent-container'),
				orderSummary = $('.order-summary-footer .error-placement').parents('.user-consent-container');
				
		if ($(window).width() > 480 && $(form).find('.error-placement').length > 0){
			$(paypalContainer).addClass('add-space');
			$(orderSummary).addClass('add-space');
		} else if ($(window).width() > 480 && !$(form).find('.error-placement').length > 0){
			$(paypalContainer).removeClass('add-space');
			$(orderSummary).removeClass('add-space');
		}
		if ($(window).width() < 480 && $(form).find('.error-placement').length > 0){
			$(paypalContainer).addClass('add-space');
			$(orderSummary).addClass('add-space');
		} else if ($(window).width() < 480 && !$(form).find('.error-placement').length > 0){
			$(paypalContainer).removeClass('add-space');
			$(orderSummary).removeClass('add-space');
		}
	}
	});
}

export default {
    init: function () {
        inputEntry();
    }
};